const firebaseConfig = {
  apiKey: "AIzaSyBIntbdXr117QUckUdIG7FGT5RZCyz5OZo",
  authDomain: "fetness-care.firebaseapp.com",
  projectId: "fetness-care",
  storageBucket: "fetness-care.appspot.com",
  messagingSenderId: "706925453260",
  appId: "1:706925453260:web:f6ba9065dc415b56898769"
  };

export default firebaseConfig;